import { TagInDatabaseSchema, TagSchema } from '@/validations/tag';
import { CollectionReference, addDoc, collection, getFirestore } from 'firebase/firestore';

import { toast } from '@/components/Toaster/Toast';

import { TagInDatabase } from './getFirebaseTag';
import { safePromise } from './safePromise';

export async function createTagInFirebase(tag: string, organizationId: string, userId: string) {
  const firestore = getFirestore();

  // Reference to the 'tags' subcollection
  const tagsRef = collection(firestore, 'organizations', organizationId, 'tags') as CollectionReference<TagInDatabase>;

  const tagData = TagInDatabaseSchema.safeParse({
    label: tag,
    user: userId,
  });

  if (!tagData.success) {
    toast({
      variant: 'error',
      title: 'Invalid tag',
      description: 'Please try again later',
    });

    return undefined;
  }

  // Get the config from the database
  const [data, error] = await safePromise(addDoc(tagsRef, tagData.data));

  if (error) {
    toast({
      variant: 'error',
      title: 'Unable to create tag',
      description: 'Please try again later',
    });

    return undefined;
  }

  const result = TagSchema.safeParse({
    id: data.id,
    label: tag,
    user: userId,
  });

  if (!result.success) {
    toast({
      variant: 'error',
      title: 'Unable to create tag',
      description: 'Please try again later',
    });

    return undefined;
  }

  return result.data;
}
